<template>
  <b-card v-if="shoIt" class="mt-3" no-body>
    <b-card-header>
      <h4>
        {{ title }}
        <!-- <b-button
          variant="outline-success"
          class="ml-1"
          size="sm"
          style="float: left"
          :href="'BI/' + biId"
        >
          <b-icon icon="pencil"></b-icon>
        </b-button> -->
        <b-button
          variant="outline-danger"
          class="ml-1"
          size="sm"
          style="float: left"
          @click="deleteItem"
          v-if="biId > 0"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
        <!-- <b-dropdown variant="outline-light" style="float: left">
          <template slot="button-content">
            <i class="flaticon2-gear"></i>
          </template>
          <b-dropdown-item :href="'BI/' + biId">ویرایش</b-dropdown-item>
          <b-dropdown-item>حذف</b-dropdown-item>
        </b-dropdown> -->
      </h4>
    </b-card-header>
    <b-card-body>
      <div class="mt-5" style="position: relative">
        <highcharts :options="chartOptions"></highcharts>
        <div v-if="emptyData" class="sampledata">
          <h2>در بازه انتخابی تراکنشی وجود ندارد</h2>
        </div>
      </div>
    </b-card-body>
    <b-modal
      :id="'my-modal' + biId"
      title="اخطار"
      ok-title="حذف"
      cancel-title="انصراف"
      ok-variant="danger"
      @ok.prevent="confirmDelete()"
    >
      <div class="d-block text-center">
        <h3>آیا مایل به حذف این نمودار هستید؟</h3>
      </div>
    </b-modal>
  </b-card>
</template>
<style>
.highcharts-credits {
  display: none;
}
.sampledata {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.55);
  vertical-align: middle;
  padding-top: 35%;
}
.sampledata h2 {
  color: white;
  text-align: center;
}
</style>
<script>
import { mapGetters } from "vuex";
import { Chart } from "highcharts-vue";
import heatmap from "highcharts/modules/heatmap";
const dayofweek = [
  "شنبه",
  "یکشنبه ",
  "دوشنبه",
  "سه شنبه",
  "چهارشنبه",
  "پنجشنبه",
  "جمعه",
  
];
const ir_dayofweek = [
  "شنبه",
  "یکشنبه ",
  "دوشنبه",
  "سه شنبه",
  "چهارشنبه",
  "پنجشنبه",
  "جمعه",
];
const colors = ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"];
import _ from "lodash";
import httpHelper from "../helpers/httpHelper";
import persianDate from "../helpers/persianDate";
export default {
  name: "shepa-chart",
  data() {
    return {
      emptyData: false,
      shoIt: false,
      chartOptions: {},
      series: [],
      categories: [],
      date_from: persianDate.getDateByFormat(
        new Date().setDate(new Date().getDate() - 14)
      ),
      date_to: persianDate.getDateByFormat(new Date()),
      miladi_fromDate: new Date().setDate(new Date().getDate() - 14),
      miladi_ToDate: null,
    };
  },
  components: {
    highcharts: Chart,
  },
  props: [
    "chartdatas",
    "charttype",
    "group_col",
    "columns",
    "title",
    "subTitle",
    "XYTitle",
    "biId",
    "resetcharts",
  ],
  computed: {
    ...mapGetters(["layoutConfig"]),
  },
  watch: {
    chartdatas: function (newVal, oldVal) {
      this.initChart();
    },
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.emptyData = false;
      this.series = [];
      this.categories = [];
      if (this.charttype == "heat") {
        this.hChartOptions();
        return;
      }

      var columns = this.columns;
      var chartDatas = this.CalcResult(
        this.chartdatas,
        this.group_col,
        columns
      );

      if (_.isEmpty(chartDatas)) {
        this.emptyData = true;
        for (let i = 0; i < 10; i++) {
          var item = {};
          item[this.columns[0].field_type + "_" + columns[0].field_name] =
            Math.floor(Math.random() * 11);
          chartDatas[i] = item;
        }
      }
      for (const key in chartDatas) {
        if (chartDatas.hasOwnProperty(key)) {
          const element = chartDatas[key];
          for (let i = 0; i < columns.length; i++) {
            if (i >= this.series.length) {
              this.series.push({
                name: columns[i].name,
                data: [],
              });
            }
            this.series[i].data.push(
              element[columns[i].field_type + "_" + columns[i].field_name]
            );
          }
          if (this.group_col != "dayofweek") {
            this.categories.push(key);
          } else {
            this.categories.push(dayofweek[key - 1]);
          }
        }
      }
      this.hChartOptions();
      return;
    },
    changeFromDate(event) {
      this.miladi_fromDate = new Date(event._i);
      this.initChart();
    },
    changeToDate(event) {
      this.miladi_ToDate = new Date(event._i);
      this.initChart();
    },
    deleteItem() {
      this.$bvModal.show("my-modal" + this.biId);
    },
    confirmDelete() {
      httpHelper.getData("BI/delete/" + this.biId).then((res) => {
        this.$bvModal.hide("my-modal" + this.biId);
        this.resetcharts();
      });
    },
    CalcResult(data, group_col, columns) {
      var self = this;
      // if (this.miladi_fromDate == null) {
      //   this.miladi_fromDate = new Date().setDate(new Date().getDate() - 14);
      // }
      // data = data.filter(function (o) {
      //   return new Date(o.date_insert) >= self.miladi_fromDate;
      // });
      // if (this.miladi_ToDate != null) {
      //   data = data.filter(function (o) {
      //     return new Date(o.date_insert) <= self.miladi_ToDate;
      //   });
      // }
      var g = _.groupBy(data, function (item) {
        return item[group_col];
      });
      const ordered = {};
      Object.keys(g)
        .sort()
        .forEach(function (key) {
          ordered[key] = g[key];
        });
      var return_data = _.mapValues(ordered, function (o) {
        var obj = {};
        for (let i = 0; i < columns.length; i++) {
          const col = columns[i];
          if (col.field_type == "sum") {
            var s = 0;
            obj[col.field_type + "_" + col.field_name] = _.sumBy(
              o,
              function (sItem) {
                return sItem[col.field_name];
              }
            );
          } else if (col.field_type == "avg") {
            var s = 0;
            obj[col.field_type + "_" + col.field_name] =
              _.sumBy(o, function (sItem) {
                return sItem[col.field_name];
              }) / o.length;
          } else if (col.field_type == "length") {
            obj[col.field_type + "_" + col.field_name] = o.length;
          } else if (col.field_type == "min") {
            obj[col.field_type + "_" + col.field_name] = _.minBy(
              o,
              function (sItem) {
                return sItem[col.field_name];
              }
            )[col.field_name];
          } else if (col.field_type == "max") {
            obj[col.field_type + "_" + col.field_name] = _.maxBy(
              o,
              function (sItem) {
                return sItem[col.field_name];
              }
            )[col.field_name];
          }
        }
        return obj;
      });
      if (group_col === "dayofweek") {
        if (_.isEmpty(return_data)) {
          this.emptyData = true;
          for (let i = 1; i < 7; i++) {
            var item = {};
            item[this.columns[0].field_type + "_" + columns[0].field_name] =
              Math.floor(Math.random() * 11);
            return_data[i] = item;
          }
        }
        const sun = return_data[1] ? return_data[1] : { sum_cost: 0 };
        const mon = return_data[2] ? return_data[2] : { sum_cost: 0 };
        const tues = return_data[3] ? return_data[3] : { sum_cost: 0 };
        const wed = return_data[4] ? return_data[4] : { sum_cost: 0 };
        const thurs = return_data[5] ? return_data[5] : { sum_cost: 0 };
        const fri = return_data[6] ? return_data[6] : { sum_cost: 0 };
        const sat = return_data[7] ? return_data[7] : { sum_cost: 0 };

        return_data[1] = sat;
        return_data[2] = sun;
        return_data[3] = mon;
        return_data[4] = tues;
        return_data[5] = wed;
        return_data[6] = thurs;
        return_data[7] = fri;
      }
      return return_data;
    },
    createAreaChart() {
      this.chartOptions = {
        chart: {
          title: this.title,
          type: this.charttype == "stackedBar" ? "bar" : this.charttype,
          height: 350,
          stacked: this.charttype == "stackedBar",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {},
        legend: {
          show: true,
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "solid",
          opacity: 1,
        },
        stroke: {
          curve: "smooth",
          show: true,
          width: 3,
          colors: [this.layoutConfig("colors.theme.base.success")],
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {},
      };
    },
    hChartOptions() {
      switch (this.charttype) {
        case "line":
          this.drowLineChart();
          break;
        case "line2":
          this.drowLinesChart();
          break;
        case "bar":
          this.drowbarChart();
          break;
        case "pie":
          this.drowpieChart();
          break;
        case "heat":
          this.drowHeatChart();
          break;
        case "column":
          this.drowColumnChart();
          break;
        default:
          break;
      }
      this.shoIt = true;
    },
    drowColumnChart() {
      this.chartOptions = {
        chart: {
          type: "column",
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },
        title: {
          text: null, //this.title
        },
        // subtitle:this.subTitle,
        colors: ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"],
        subtitle: {
          text: this.subTitle,
          style: {
            color: "red",
          },
        },
        xAxis: {
          categories: this.categories,
          title: {
            text: this.XYTitle.x_title,
            align: "high",
          },
        },
        yAxis: {
          title: {
            text: this.XYTitle.y_title,
            align: "high",
          },
          labels: {
            formatter: function () {
              return this.value.toLocaleString();
            },
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              "<div style='direction:rtl;'><h6 style='text-align:right'>" +
              this.x +
              "</h6>" +
              this.series.name +
              ":" +
              Number(this.y).toLocaleString() +
              "</div>"
            );
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
        },
        series: this.series,
      };
    },
    drowLineChart() {
      this.chartOptions = {
        chart: {
          type: "spline",
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },
        title: {
          text: null, //this.title
        },
        subtitle: {
          text: this.subTitle,
          style: {
            color: "red",
          },
          verticalAlign: "top",
        },
        colors: ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"],
        // subtitle: {
        //   text: "Source: WorldClimate.com"
        // },
        xAxis: {
          categories: this.categories,
          title: {
            text: this.XYTitle.x_title,
            align: "high",
          },
        },
        yAxis: {
          title: {
            text: this.XYTitle.y_title,
            align: "high",
          },
          labels: {
            formatter: function () {
              return this.value.toLocaleString();
            },
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              "<div style='direction:rtl;'><h6 style='text-align:right'>" +
              this.x +
              "</h6>" +
              this.series.name +
              ":" +
              Number(this.y).toLocaleString() +
              "</div>"
            );
          },
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
        },
        series: this.series,
      };
    },
    drowbarChart() {
      this.chartOptions = {
        chart: {
          type: "column",
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },
        colors: colors,
        title: {
          text: null, //this.title
        },
        xAxis: {
          categories: this.categories,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              "<div style='direction:rtl;'><h6 style='text-align:right'>" +
              this.x +
              "</h6>" +
              this.series.name +
              ":" +
              Number(this.y).toLocaleString() +
              "</div>"
            );
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: this.series,
      };
    },
    drowpieChart() {
      var self = this;
      var pieSeries = [];
      this.categories.forEach((element, index) => {
        pieSeries.push({
          name: element,
          y: this.series[0].data[index],
        });
      });
      this.chartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          style: {
            fontFamily: "IRANsans",
          },
        },
        colors: colors,
        title: {
          text: null, // this.title
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              "<div style='direction:rtl;'><h6 style='text-align:right'>" +
              this.key +
              "</h6>" +
              self.title +
              ":" +
              Number(this.y).toLocaleString() +
              "</div>"
            );
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
          },
        },
        series: [
          {
            name: "",
            data: pieSeries,
          },
        ],
      };
    },
    getDayOfWeek(dayIndex){
      if(dayIndex == 7){
        return 0;
      }
      return dayIndex;
    },
    drowHeatChart() {
      var self = this;
      var series = [];
      var data = this.chartdatas;
      // if (this.miladi_fromDate == null) {
      //   this.miladi_fromDate = new Date().setDate(new Date().getDate() - 30);
      // }
      // data = data.filter(function (o) {
      //   return new Date(o.date_insert) >= self.miladi_fromDate;
      // });
      // if (this.miladi_ToDate != null) {
      //   data = data.filter(function (o) {
      //     return new Date(o.date_insert) <= self.miladi_ToDate;
      //   });
      // }
      if (!_.isEmpty(data)) {
        var g = _.groupBy(data, function (o) {
          return o.dayofweek;
        });
        for (const key in g) {
          if (g.hasOwnProperty(key)) {
            g[key] = _.groupBy(g[key], function (o) {
              return o.TIMEONLY;
            });
            for (const timeonly in g[key]) {
              if (g[key].hasOwnProperty(timeonly)) {
                series.push([
                  parseInt(timeonly),
                  parseInt(key)==7?0:parseInt(key),
                  g[key][timeonly].length,
                ]);
              }
            }
          }
        }
      } else {
        this.emptyData = true;
        for (let i = 0; i < 24; i++) {
          for (let j = 0; j < 7; j++) {
            series.push([i, j, parseInt(Math.random() * 100)]);
          }
        }
      }

      this.chartOptions = {
        chart: {
          type: "heatmap",
          plotBorderWidth: 1,
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },

        title: {
          text: "",
        },
        subtitle: {
          text: this.subTitle,
          style: {
            color: "red",
          },
          verticalAlign: "top",
        },
        xAxis: {
          categories: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24,
          ],
          title: {
            text: this.XYTitle.x_title,
            align: "high",
          },
        },

        yAxis: {
          categories: ir_dayofweek,
          title: {
            text: this.XYTitle.y_title,
            align: "high",
          },
          reversed: false,
        },

        accessibility: {
          point: {
            descriptionFormatter: function (point) {
              var ix = point.index + 1,
                xName = self.getPointCategoryName(point, "x"),
                yName = self.getPointCategoryName(point, "y"),
                val = point.value;
              return ix + ". " + xName + " sales " + yName + ", " + val + ".";
            },
          },
        },

        colorAxis: {
          min: 0,
          minColor: "#FFFFFF",
          maxColor: "#0d7d65",
        },

        legend: {
          align: "right",
          layout: "vertical",
          margin: 0,
          verticalAlign: "top",
          y: 25,
          symbolHeight: 280,
        },

        tooltip: {
          formatter: function () {
            return (
              "<p >" +
              self.getPointCategoryName(this.point, "y") +
              " ساعت " +
              self.getPointCategoryName(this.point, "x") +
              " تعداد تراکنش: " +
              this.point.value +
              " </p>"
            );
          },
        },

        series: [
          {
            name: "میزان فروش در ساعت",
            borderWidth: 1,
            data: series,
            dataLabels: {
              enabled: false,
              color: "#000000",
            },
          },
        ],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                yAxis: {
                  labels: {
                    formatter: function () {
                      return this.value.charAt(0);
                    },
                  },
                },
              },
            },
          ],
        },
      };
    },
    getPointCategoryName(point, dimension) {
      var series = point.series,
        isY = dimension === "y",
        axis = series[isY ? "yAxis" : "xAxis"];
      return axis.categories[point[isY ? "y" : "x"]];
    },
    drowLinesChart() {
      var self = this;
      var series = [];
      var data = this.chartdatas;
      if (!_.isEmpty(data)) {
        var g = _.groupBy(data, function (o) {
          return o.dayofweek;
        });
        for (const key in g) {
          if (g.hasOwnProperty(key)) {
            g[key] = _.groupBy(g[key], function (o) {
              return o.TIMEONLY;
            });
            var dataForS = [];
            for (const timeonly in g[key]) {
              if (g[key].hasOwnProperty(timeonly)) {
                dataForS.push({
                  label: timeonly,
                  value: g[key][timeonly].length,
                });
              }
            }
          }
          for (let i = 0; i < 24; i++) {
            var item = dataForS.find(function (o) {
              return parseInt(o.label) == i;
            });
            var value = 0;
            if (item) {
              value = item.value;
            }
            var selectedS = series.find(function (o) {
              return o.name == key;
            });
            if (selectedS) {
              selectedS.data.push(value);
            } else {
              series.push({
                name: key,
                data: [value],
              });
            }
          }
        }
      } else {
        this.emptyData = true;
        for (let i = 0; i < 24; i++) {
          for (let j = 0; j < 7; j++) {
            series.push([i, j, parseInt(Math.random() * 100)]);
          }
        }
      }

      for (let i = 0; i < series.length; i++) {
        series[i].name = dayofweek[parseInt(series[i].name) - 1];
      }
      this.series = series;
      this.chartOptions = {
        chart: {
          type: "spline",
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },
        title: {
          text: null, //this.title
        },
        subtitle: {
          text: this.subTitle,
          style: {
            color: "red",
          },
          verticalAlign: "top",
        },
        colors: ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"],
        // subtitle: {
        //   text: "Source: WorldClimate.com"
        // },
        xAxis: {
          categories: [],
          title: {
            text: "ffff",
            align: "high",
          },
        },
        yAxis: {
          title: {
            text: "ffff",
            align: "high",
          },
          labels: {
            formatter: function () {
              return this.value.toLocaleString();
            },
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              "<div style='direction:rtl;'><h6 style='text-align:right'>ساعت " +
              this.x +
              "</h6> تعداد تراکنش ها در " +
              this.series.name +
              ":" +
              Number(this.y).toLocaleString() +
              " عدد</div>"
            );
          },
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
        },
        series: this.series,
      };
    },
  },
};
</script>
